import * as React from 'react';

import {Select} from '../select/select';

type Props = {
    filter: string | null | undefined;
    onChange: (arg1: string) => any;
    dateRangeOptions: {
        id: string;
        value: string;
    }[];
};

/*
 * Responsible for showing a blue select dropdown with sane
 * simple date range values (i.e. 'Hour' or 'This week').
 */
export function DateRangePickerSimple(props: Props) {
    // @ts-expect-error
    const handleChange = ({id}) => {
        props.onChange(id);
    };

    return (
        <Select
            // @ts-expect-error
            size='large'
            value={props.dateRangeOptions.find((opt) => opt.id === props.filter)}
            labelKey='value'
            selectValues={props.dateRangeOptions}
            styleOptions={{filled: true, color: 'blue'}}
            onChange={handleChange}
        />
    );
}
